import { capitalize } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useCloseModal, useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'

const formatServiceName = service => {
  if (service === 'chat_pro') return 'chatPro'
  return capitalize(service)
}

const ModalHeader = () => {
  const { t } = useTranslation('listIntegrations')
  const { service } = useModalData()
  const onClose = useCloseModal()
  const serviceName = formatServiceName(service)

  return (
    <>
      <Grid justify="space-between">
        <Col flex={1}>
          <Title size="h4" noMargin>
            {t('newIntegrationWithService', { service: serviceName })}
          </Title>
          <SmallText color="dark4">{t('tokenIntegrationDescription', { service: serviceName })}</SmallText>
        </Col>
      </Grid>
      <LineSeparator weight={4} />
    </>
  )
}

export default ModalHeader
